// src/features/product/components/AddProductModal.jsx
import { useEffect, useRef, useState } from 'react';
import { Modal, Button, Form, Spinner, Alert, Row, Col, Container, Tabs, Tab, Card, InputGroup } from 'react-bootstrap';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ProductDetailTable from './ProductDetailTable';
import { useProductDetails } from '../hooks/useProductDetails';
import { useProducts } from '../hooks/useProducts';
import { IoReloadCircle } from 'react-icons/io5';
import { GiReloadGunBarrel } from 'react-icons/gi';
import { FaPlus } from 'react-icons/fa';
import Swal from 'sweetalert2';


const ProductModalAddDetail = ({
    show,
    handleClose,
    handleAddProduct,
    parsingDataEdit,
    editDescriptionProduct,
    termConditionProduct,
    addProductDetails,
    editProductDetails,
    showModalAddCategoriesDetail,
    data }) => {

    const { reloadCategoriesProducIitem } = useProductDetails()

    const editorRef = useRef(null);
    const quillRef = useRef(null);
    const [editorValue, setEditorValue] = useState('');

    const editorTermAndConditionRef = useRef(null);
    const quillTermAndConditionRef = useRef(null);
    const [editorTermAndConditionValue, setEditorTermAndConditionValue] = useState('');

    const editorGuidelinesRef = useRef(null);
    const quillGuidelinesRef = useRef(null);
    const [editorGuidelinesValue, setEditorGuidelinesValue] = useState('');

    const [loading, setLoading] = useState(null);
    const [loadingDetail, setLoadingDetail] = useState(null);
    const [detailsReady, setDetailsReady] = useState(false); // Tracks if `details` are ready
    const [error, setError] = useState(null);

    const [productDetail, setProductDetail] = useState({
        name: '',
        product: ''
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const cleanedValue = value.replace(/[^a-zA-Z0-9\s\/\\-]/g, '');
        e.target.value = cleanedValue;
        setProductDetail((prevProduct) => ({
            ...prevProduct,
            [name]: cleanedValue,
            product: parsingDataEdit?.id,
        }));
    };

    const defaultData = {
        description: parsingDataEdit?.description?.length ? parsingDataEdit.description : '',
        termCondition: parsingDataEdit?.term_and_condition?.length ? parsingDataEdit.term_and_condition : '',
        guidelines: parsingDataEdit?.guidelines?.length ? parsingDataEdit.guidelines : '',
    };

    useEffect(() => {
        const existingToolbars = document.querySelectorAll('.ql-toolbar');
        existingToolbars.forEach(toolbar => toolbar.remove());

        if (show && editorRef.current && !quillRef.current) {
            quillRef.current = new Quill(editorRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline'],
                        [{ 'align': [] }],
                        ['link'],
                        ['image'],
                    ],
                },
            });

            quillRef.current.root.innerHTML = defaultData.description;
            quillRef.current.on('text-change', () => {
                setEditorValue(quillRef.current.root.innerHTML);
            });
        }

        if (show && editorTermAndConditionRef.current && !quillTermAndConditionRef.current) {
            quillTermAndConditionRef.current = new Quill(editorTermAndConditionRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline'],
                        [{ 'align': [] }],
                        ['link'],
                        ['image'],
                    ],
                },
            });

            quillTermAndConditionRef.current.root.innerHTML = defaultData.termCondition;
            quillTermAndConditionRef.current.on('text-change', () => {
                setEditorTermAndConditionValue(quillTermAndConditionRef.current.root.innerHTML);
            });
        }

        if (show && editorGuidelinesRef.current && !quillGuidelinesRef.current) {
            quillGuidelinesRef.current = new Quill(editorGuidelinesRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline'],
                        [{ 'align': [] }],
                        ['link'],
                        ['image'],
                    ],
                },
            });

            quillGuidelinesRef.current.root.innerHTML = defaultData.guidelines;
            quillGuidelinesRef.current.on('text-change', () => {
                setEditorGuidelinesValue(quillGuidelinesRef.current.root.innerHTML);
            });
        }

        return () => {
            if (quillRef.current) quillRef.current = null; // Destroy Quill instance
            if (quillTermAndConditionRef.current) quillTermAndConditionRef.current = null; // Destroy Quill instance
            if (quillGuidelinesRef.current) quillGuidelinesRef.current = null; // Destroy Quill instance
        };
    }, [show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Start loading
        const dataEditProduct = {
            id: parsingDataEdit.id,
            description: editorValue,
            term_and_condition: editorTermAndConditionValue,
            guidelines: editorGuidelinesValue,
        }

        try {
            await editDescriptionProduct(dataEditProduct);
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Product description saved successfully!",
            });
            handleClose()
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Failed",
                text: "Failed to save product description. Please try again.",
            });
        } finally {
            setLoading(false);
            handleClose()
        }
    };

    const handleSubmitDetail = async (e) => {
        e.preventDefault();
        setLoadingDetail(true);
        if (productDetail?.id) {
            editProductDetails(productDetail)
        } else {
            addProductDetails(productDetail)
        }
        setProductDetail({
            name: ''
        })
        setLoadingDetail(false);
    };

    const handleCategoryProductEdit = (row) => {
        setProductDetail(row)
    };

    const handleShowModalCategoriesDetail = (row) => {
        console.log(row)
        showModalAddCategoriesDetail(row)
    }

    const handleReload = async () => {
        const rowData = {
            id_paket: parsingDataEdit?.id_paket,
            product: parsingDataEdit?.id
        }

        console.log('load data by id ', parsingDataEdit?.id_paket)
        reloadCategoriesProducIitem(rowData)
    }

    const handleReloadUpdate = async (row) => {
        console.log('handleReloadUpdate ', row)
    }

    return (
        <Modal
            size="xl"  // 'xl' size for larger modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
            dialogClassName="fullscreen-modal"  // Use dialogClassName for targeting modal styles if needed
            style={{
                maxWidth: '100%',
                height: '100vh', // Fullscreen height
                margin: 0, // Remove margin
                padding: 0, // Remove padding
            }}>
            <Modal.Header closeButton>
                <Modal.Title>Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body className="grid-example">
                <Tabs
                    defaultActiveKey="description"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="description" title="Description">
                        {loading ? (
                            <div className="loading-page">
                                <h3>Loading...</h3>
                                <p>Please wait while we save your data.</p>
                                {/* Add any spinner or animation here */}
                            </div>
                        ) : (
                            <Form onSubmit={handleSubmit} className='mb-3'>
                                <Container>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <Form.Label>Description</Form.Label>
                                            <Form.Group className="mb-3">
                                                <div ref={editorRef} style={{ height: '300px', border: '1px solid #ccc' }}></div>
                                            </Form.Group>
                                            <Form.Label>Guidelines</Form.Label>
                                            <Form.Group className="mb-3">
                                                <div ref={editorGuidelinesRef} style={{ height: '300px', border: '1px solid #ccc' }}></div>
                                            </Form.Group>
                                            <Form.Label>Term & Condition</Form.Label>
                                            <Form.Group className="mb-3">
                                                <div ref={editorTermAndConditionRef} style={{ height: '300px', border: '1px solid #ccc' }}></div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Button variant="primary" type="submit">
                                        Add
                                    </Button>
                                </Container>
                            </Form>
                        )}
                    </Tab>
                    <Tab eventKey="product_details" title="Product Details">
                        {loadingDetail ? (
                            <div className="loading-page">
                                <h3>Loading...</h3>
                                <p>Please wait while we save your data.</p>
                            </div>
                        ) : (
                            <Container>
                                <Row>
                                   
                                    <Container>
                                        <Row>
                                            {/* <Button variant="outline-secondary"
                                                onClick={() => handleReload(parsingDataEdit)}
                                            >
                                                <IoReloadCircle />
                                                <span className="d-none d-sm-inline">Reload</span>
                                            </Button> */}
                                            <ProductDetailTable
                                                handleReload={handleReload}
                                                productDetailSingle={parsingDataEdit}
                                                handleCategoryProductEdit={handleCategoryProductEdit}
                                                onAddDetailCategories={handleShowModalCategoriesDetail}
                                                handleClose={handleClose}
                                            />
                                        </Row>
                                    </Container>
                                </Row>
                            </Container>
                        )}
                    </Tab>
                    {/* <Tab eventKey="contact" title="Contact">
                        Tab content for Contact
                    </Tab> */}
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};

export default ProductModalAddDetail;
